import { render } from "./GaugeChart.vue?vue&type=template&id=18a81c72&scoped=true"
import script from "./GaugeChart.vue?vue&type=script&lang=js"
export * from "./GaugeChart.vue?vue&type=script&lang=js"

import "./GaugeChart.vue?vue&type=style&index=0&id=18a81c72&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18a81c72"]])

export default __exports__